"use client";

import createIcon from './util/createIcon';
export default createIcon('M11 9.47V11H14.76L13 14.53V13H9.24L11 9.47M13 1L6 15H11V23L18 9H13V1Z', 'LightningBoltOutline');